export const i18nKeys = {
	'ngc.accessories.headline': 'Equipment',
	'ngc.accessories.search': 'Search Accessories...',
	'ngc.actions.addToConfiguration': 'Add to configuration',
	'ngc.actions.audiCode': 'Audi Code',
	'ngc.actions.cancel': 'Cancel',
	'ngc.actions.changeConfiguration': 'Change configuration',
	'ngc.actions.changeLeasingRate': 'Change leasing rate',
	'ngc.actions.close': 'Close',
	'ngc.actions.openFullscreen': 'Open Fullscreen',
	'ngc.actions.closeFullscreen': 'Close Fullscreen',
	'ngc.actions.information': 'Information',
	'ngc.actions.previous': 'Previous',
	'ngc.actions.next': 'Next',
	'ngc.actions.compare': 'Compare',
	'ngc.actions.openAVP': 'Open 360° View',
	'ngc.actions.backFromError': 'Back from 360° View error',
	'ngc.actions.closeAVP': 'Close 360° View',
	'ngc.actions.reset': 'Reset',
	'ngc.actions.apply': 'Apply',
	'ngc.actions.ok': 'Ok',
	'ngc.actions.getYourCar': 'Review Build',
	'ngc.actions.includedInConfiguration': 'Included in configuration',
	'ngc.actions.moreInfo': 'More information',
	'ngc.actions.onlineLeasing': 'Online Leasing',
	'ngc.actions.productDataSheet': 'Product data sheet',
	'ngc.actions.savePDF': 'Save PDF',
	'ngc.actions.showDetails': 'Show Details',
	'ngc.actions.hideDetails': 'Hide Details',
	'ngc.actions.showPriceDetails': 'Show Price Details',
	'ngc.actions.viewSpecialOffers': 'View all special offers',
	'ngc.actions.showStandardEquipment': 'Show standard equipment',
	'ngc.actions.technicalData': 'Technical Data',
	'ngc.actions.viewTechnicalData': 'View Technical Data',
	'ngc.audiCode.disclaimner':
		'To access a saved configuration with an Audi Code, be aware that it will replace your current configuration.',
	'ngc.audiCode.enter': 'Enter your Audi Code',
	'ngc.audiCode.explanation':
		'The Audi Code allows you to retrieve your configuration either online or through your Audi partner.',
	'ngc.audiCode.link': 'Direct link',
	'ngc.audiCode.loadAudiCode': 'Load Audi Code',
	'ngc.audiCode.yourCode': 'Your Audi Code',
	'ngc.common.all': 'All',
	'ngc.common.comparison.emtpy': 'Choose another option to make a before/after comparison.',
	'ngc.common.copied': 'Copied',
	'ngc.common.change': 'Change',
	'ngc.common.NotAvailable': 'Not available',
	'ngc.common.note': 'Note',
	'ngc.common.or': 'or',
	'ngc.common.piece': 'Piece',
	'ngc.common.priceNotAvailable': 'Price not available',
	'ngc.common.standard': 'Standard',
	'ngc.common.steps': 'Step {{step}} from {{total}}',
	'ngc.common.title.configurator': 'Configurator',
	'ngc.conflict.accept': 'Accept changes',
	'ngc.conflict.added': '{{count}} Items added',
	'ngc.conflict.added.subtext': 'These items will be added to enable your selected item.',
	'ngc.conflict.adjust': 'The options you have selected cannot be combined.',
	'ngc.conflict.conflictingOption': 'Your selection',
	'ngc.conflict.decline': 'Decline',
	'ngc.conflict.priceChange': 'Price change',
	'ngc.conflict.removed': '{{count}} Items will be removed',
	'ngc.conflict.removed.subtext': 'These items will be removed to enable your selected items. No action is required.',
	'ngc.conflict.total': 'Total price',
	'ngc.conflict.showOtherOptions': 'Show other options ({{count}})',
	'ngc.conflict.changesRequired': '{{count}} Changes required from you',
	'ngc.conflict.changesRequired.subtext':
		'To enable your selected item various changes are needed. The default item is currently selected, please confirm your selection.',
	'ngc.currency.addtionalCost': 'Total additional cost',
	'ngc.currency.subtotal': 'Subtotal',
	'ngc.currency.calculatingPrice': 'Calculating price',
	'ngc.currency.minPriceWithVAT': 'from {{value}}',
	'ngc.currency.monthlyRate.footnote': 'MONTHLY RATE TEXT',
	'ngc.currency.monthlyRate': '{{value}}/Month',
	'ngc.currency.priceExcludingVAT': '{{value}}',
	'ngc.currency.priceWithOptionalVAT': '{{value}}',
	'ngc.currency.priceWithVAT': '{{value}}',
	'ngc.currency.withVAT': 'Total price with tax',
	'ngc.dialogs.benefits': 'Benefits',
	'ngc.dialogs.comparison.trigger': 'Compare Options',
	'ngc.dialogs.comparison.title': 'Comparing Equipment Options',
	'ngc.dialogs.comparison.subtitle': 'Select and compare our various different upgrade options.',
	'ngc.dialogs.euTyreLabel.disclaimer':
		'It is not possible to order a specific make of tyre for logistical and production reasons.',
	'ngc.dialogs.euTyreLabel.linkText': 'Information on EU tire labeling',
	'ngc.dialogs.features': 'Features',
	'ngc.dialogs.packageContent': 'Package content',
	'ngc.dialogs.qrCode': 'Scan this QR-Code with your smartphone to save this configuration.',
	'ngc.equipmentAndAccessories.headline': 'Equipment & Accessories',
	'ngc.accessories.showNextItems': 'Show the next {{itemsToAdd}} items',
	'ngc.accessories.itemCount': 'Viewing 1 - {{itemCount}} of {{totalCount}}',
	'ngc.equipmentAndAccessories.noResults': 'Unfortunately your search did not return results.',
	'ngc.equipmentAndAccessories.noResults.infoText': `Make sure all terms are spelled correctly. Maybe your search term is too specific?
Alternatively try entering a different term or reset the form.`,
	'ngc.equipmentAndAccessories.resetSearch': 'Reset search',
	'ngc.equipmentAndAccessories.filter.label': 'Filter by category',
	'ngc.equipment.audiOriginalAccessories': 'Audi Original Accessories',
	'ngc.equipment.bodyPaintFinishes': 'Body paint finishes',
	'ngc.equipment.equipmentHighlights': 'Equipment Highlights',
	'ngc.equipment.equipmentPackages': 'Equipment Packages',
	'ngc.equipment.headlights': 'Headlights',
	'ngc.equipment.interior': 'Interior',
	'ngc.equipment.interiorPackages': 'Interior Packages',
	'ngc.equipment.interiorPackages.tile1': 'Standard',
	'ngc.equipment.interiorPackages.tile2': 'Sport',
	'ngc.equipment.package': 'Package',
	'ngc.equipment.packages': 'Packages',
	'ngc.equipment.paintTypes': 'Paint types',
	'ngc.equipment.contrastPaints': 'Contrast paint',
	'ngc.equipment.rims': 'Rims',
	'ngc.equipment.rims.dialog.trigger': 'Tyre-Lable Information',
	'ngc.equipment.seatCover': 'Seat cover',
	'ngc.equipment.seats': 'Seats',
	'ngc.equipment.standard': 'Standard equipment',
	'ngc.equipment.steeringWheels': 'Steering wheels',
	'ngc.equipment.trimlineAndEngine.drivetrain.priceDisclaimer': 'Engine price disclaimer',
	'ngc.equipment.trimlineAndEngine': 'Trim line and engine',
	'ngc.equipment.trimline': 'Trim line',
	'ngc.equipment.engine': 'Engine',
	'ngc.errors.audiCode.invalid': 'Your Audi Code is invalid.',
	'ngc.errors.conflict':
		'The conflict cannot currently be resolved due to maintenance work. We apologize for any inconvenience.',
	'ngc.errors.couldNotLoadAudiCode': 'Could not load Audi Code.',
	'ngc.errors.notChangeable.message':
		'<p>The selected option ({{itemName}}) cannot be modified in the current state. This may be due to one of the following reasons:</p>\n<ul>\n<li>The chosen option must be replaced with an equivalent option.</li>\n<li>The chosen option is included by default in its configuration.</li>\n</ul>',
	'ngc.errors.notChangeable.title': 'Not Changeable',
	'ngc.errors.unexpected.message':
		'Due to technical problems, the selected action cannot be carried out at the moment. We apologize for any inconvenience and will try to fix the problem as soon as possible.',
	'ngc.errors.unexpected.title': 'Unexpected Error',
	'ngc.errors.videonotsupported': 'Sorry - your browser does not support this video',
	'ngc.avp.galleryControl': 'Show 3D view',
	'ngc.avp.galleryErrorText': 'The 3D functionality is currently not available, please try again later',
	'ngc.avp.galleryControlBackError': 'Back to gallery',
	'ngc.priceDetails.airConditioningLevy': 'Federal Air Conditioner Excise Tax',
	'ngc.priceDetails.audiCare': 'AudiCare: 4 years premium service',
	'ngc.priceDetails.bpm': 'bpm',
	'ngc.priceDetails.charges': 'Freight and PDI',
	'ngc.priceDetails.dealerAdminFee': 'Dealer Administration Fee (maximum)',
	'ngc.priceDetails.evVatTotal': 'Ev VAT Total',
	'ngc.priceDetails.financeableTotal': 'Financeable Total',
	'ngc.priceDetails.luxuryTax': 'Federal Luxury Tax',
	'ngc.priceDetails.model': 'Basic Price',
	'ngc.priceDetails.modelPriceWithFees': 'Model Price with Fees',
	'ngc.priceDetails.nettoBase': 'netto base',
	'ngc.priceDetails.nettoOptions': 'netto options',
	'ngc.priceDetails.nonFinanceableTotal': 'non financeable total',
	'ngc.priceDetails.options': 'Optional Equipment',
	'ngc.priceDetails.priceAsBuilt': 'Price as Built',
	'ngc.priceDetails.rotr': 'OTR',
	'ngc.priceDetails.rotrRate': 'First registration fee, delivery cost and vehicle excise duty (VED)',
	'ngc.priceDetails.privateLeasing': 'Private Leasing',
	'ngc.priceDetails.deliveryCosts': 'Plus delivery costs',
	'ngc.priceDetails.servicePackage': 'service package',
	'ngc.priceDetails.taxableBenefit1': 'taxable benefit 1',
	'ngc.priceDetails.taxableBenefit2': 'taxable benefit 2',
	'ngc.priceDetails.taxTotal': 'Tax Total',
	'ngc.priceDetails.taxTotalCO2': 'Tax Total CO2',
	'ngc.priceDetails.taxTotalExclScrapFree': 'Tax Total Excluding Scrap Free',
	'ngc.priceDetails.taxTotalNOx': 'Tax Total NOx',
	'ngc.priceDetails.taxTotalWeight': 'Tax Total Weight',
	'ngc.priceDetails.taxTotalWithoutVat': 'Tax Total without VAT',
	'ngc.priceDetails.title': 'Price Details',
	'ngc.priceDetails.total': 'RRP (including optional equipment)',
	'ngc.priceDetails.totalPrice': 'Total price',
	'ngc.priceDetails.totalRate': 'Total Rate',
	'ngc.priceDetails.totalWithCharges': 'Total with Charges',
	'ngc.priceDetails.vat': 'vat',
	'ngc.priceDetails.subtotal.tooltip':
		'The subtotal amount consists of the base price of the vehicle and the chosen optional equipment.',
	'ngc.priceDetails.importCharge': 'Added import fee',
	'ngc.priceDetails.destinationCharge': 'Freight and PDI',
	'ngc.remarks.optionNotShownInImages': 'This option is not shown in the vehicle images presented here.',
	'ngc.summary.overview': 'Configuration Overview',
	'ngc.summary.omnibus.trigger': 'Lowest price in the last 30 days',
	'ngc.summary.remark':
		'Comprehensive price as built includes vehicle price, vehicle options, Freight and PDI, Dealer Administration Fee, Federal Air Conditioner Excise Tax and, where applicable, Federal Luxury Tax. Audi RS Q8 is subject to Green Levy charge of $1,000 and Audi R8 quattro models are subject to Green Levy charge of $2,000. Price excludes sales taxes, license, insurance, registration, provincial fees (OMVIC/AMVIC and tire levy) and any dealer offered equipment or services. Price shown for accessories is for parts only and does not include installation / labour. The dealer administration fee is set by, and varies by dealer, up to $500. In Ontario and Alberta, a fee of $10 and $6.25 respectively is payable by dealers to their motor vehicle council (OMVIC in ON and AMVIC in AB) for each vehicle sold. The $100 federal air conditioner tax is payable for all new vehicles with air conditioning by Audi to the government. An advanced disposal fee for new tires is payable by purchasers in some provinces. Federal Luxury Tax and Federal Green Levy are payable to the federal government. In QC, for lease and financing, a fee of up to $50 is payable to RDPRM (includes government registration fee and lien registering agent’s fee). Price shown is for information and is not an offer. Actual price will vary based on the final negotiated price and terms agreed upon with the Audi dealer. Dealer may sell or lease for less.',
	'ngc.summary.alternativeRemark': 'All Information is based on the characteristics of the market',
	'ngc.summary.title': 'Summary',
	'ngc.technicalData.brakeSystem': 'Brake System',
	'ngc.technicalData.wltpLink': 'What is WLTP?',
	'ngc.technicalData.carlineModel': '{{carline}} with {{model}}',
	'ngc.technicalData.consumptionAndEmission.fuelType': 'Fuel Type',
	'ngc.technicalData.consumptionAndEmission.fuelConsumption': 'Fuel Consumption',
	'ngc.technicalData.consumptionAndEmission.nedc': 'Fuel Consumption',
	'ngc.technicalData.consumptionAndEmission': 'Consumption and Emission (WLTP)',
	'ngc.technicalData.consumption': 'Consumption',
	'ngc.technicalData.driveline': 'Driveline',
	'ngc.technicalData.electricDrive': 'Electric Drive',
	'ngc.technicalData.combustionDrive': 'Combustion engine',
	'ngc.technicalData.engine': 'Engine',
	'ngc.technicalData.insuranceClasses': 'Insurance Classes',
	'ngc.technicalData.landingGear': 'Suspension',
	'ngc.technicalData.noiseLevel': 'Noise level',
	'ngc.technicalData.notAvailable':
		'Unfortunately, the technical data is currently not available due to maintenance work. We apologize for any inconvenience.',
	'ngc.technicalData.performanceData': 'Performance Data',
	'ngc.technicalData.section.consumptionAndEmission.eecTitle': 'CO₂ Efficiancy class',
	'ngc.technicalData.section.consumptionAndEmission.eecDisclaimer':
		'Only consumption and emission values according to WLTP and not NEDC are available for the vehicle.',
	'ngc.technicalData.section.consumptionAndEmission.eecTaxLabel': 'Annual tax for this vehicle',
	'ngc.technicalData.section.consumptionAndEmission.eecRemark': 'Remark for the EEC Label',
	'ngc.technicalData.section.consumptionAndEmission.eecConsumptionPriceLabelValues':
		'Electricity costs for a mileage of {{mileage}} km at an electricity price of {{electricityPrice}} Euro/kWh',
	'ngc.technicalData.steeringSystem': 'Steering',
	'ngc.technicalData.trailerWeightLimit': 'Trailer Weight Limit',
	'ngc.technicalData.volumes': 'Volumes',
	'ngc.technicalData.weights': 'Weights',
	'ngc.technicalData.envkv.title': 'Informationen über den Energieverbrauch und die CO2-Emissonen des neuen PKW',
	'ngc.technicalData.envkv.marker': 'Marke:',
	'ngc.technicalData.envkv.driveType': 'Antriebsart:',
	'ngc.technicalData.envkv.electricDrive': 'Elektromotor',
	'ngc.technicalData.envkv.combustionDrive': 'Verbrennungsmotor',
	'ngc.technicalData.envkv.hybridDrive': 'Plug-In-Hybrid',
	'ngc.technicalData.envkv.fuel': 'Kraftstoff:',
	'ngc.technicalData.envkv.tradeName': 'Handelsbezeichnung:',
	'ngc.technicalData.envkv.otherEnergy': 'Anderer Energieträger:',
	'ngc.technicalData.envkv.energyConsumption': '<strong>Energieverbrauch</strong> (kombiniert):',
	'ngc.technicalData.envkv.energyConsumptionPhev': '<strong>Energieverbrauch</strong> (gewichtet kombiniert):',
	'ngc.technicalData.envkv.co2Emission': '<b>CO₂-Emissionen</b> (kombiniert):',
	'ngc.technicalData.envkv.co2EmissionPhev': '<b>CO₂-Emissionen</b> (gewichtet kombiniert):',
	'ngc.technicalData.envkv.co2Emission.remark':
		'Es werden nur die CO₂-Emissionen angegeben, die durch den Betrieb des Pkw entstehen. CO₂-Emissionen, die durch die Produktion und Bereitstellung des Pkw sowie des Kraftsoffes bzw. der Energieträger entstehen oder vermieden werden, werden bei der Ermittlung der CO₂-Emissionen gemäß WLTP nicht berücksichtigt.',
	'ngc.technicalData.envkv.electricRanges': 'Elektrische Reichweite:',
	'ngc.technicalData.envkv.electricRangesPhev': 'Elektrische Reichweite (EAER):',
	'ngc.technicalData.envkv.eec.subtitle': 'Auf Grundlage der CO₂-Emissionen (kombiniert)',
	'ngc.technicalData.envkv.eec.subtitlePhev': 'Auf Grundlage der CO₂-Emissionen',
	'ngc.technicalData.envkv.moreValues': 'Weitere Angaben:',
	'ngc.technicalData.envkv.electricConsumption': 'Stromverbrauch kombiniert',
	'ngc.technicalData.envkv.consumption.low': 'Innenstadt',
	'ngc.technicalData.envkv.consumption.medium': 'Stadtrand',
	'ngc.technicalData.envkv.consumption.high': 'Landstraße',
	'ngc.technicalData.envkv.consumption.extraHigh': 'Autobahn',
	'ngc.technicalData.envkv.electricConsumptionPHEV': 'Stromverbrauch bei rein elekrischem Betrieb kombiniert',
	'ngc.technicalData.envkv.fuelConsumption': 'Kraftstoffverbrauch kombiniert',
	'ngc.technicalData.envkv.fuelConsumptionPHEV': 'Kraftstoffverbrauch bei entladener Batterie kombiniert',
	'ngc.technicalData.envkv.energyCost': 'Energiekosten bei 15.000 km Jahresfahrleistung:',
	'ngc.technicalData.envkv.electricityPrice': 'Strompreis:',
	'ngc.technicalData.envkv.fuelPrice': 'Kraftstoffpreis:',
	'ngc.technicalData.envkv.yearlyAverage': 'Jahresdurchschnitt',
	'ngc.technicalData.envkv.yearlyAveragePhev': 'jeweils Jahresdurchschnitt',
	'ngc.technicalData.envkv.co2Cost': 'Mögliche CO₂-Kosten über die nächsten 10 Jahre (15.000 km/Jahr):',
	'ngc.technicalData.envkv.co2Cost.low': 'bei einem angenommenen niedrigen durchschnittlichen CO₂-Preis von',
	'ngc.technicalData.envkv.co2Cost.medium': 'bei einem angenommenen mittleren durchschnittlichen CO₂-Preis von',
	'ngc.technicalData.envkv.co2Cost.high': 'bei einem angenommenen hohen durchschnittlichen CO₂-Preis von',
	'ngc.technicalData.envkv.co2Cost.remark':
		'Aufgrund der CO₂-Bepreisung sind künftig Erhöhungen der Kraftstoffkosten möglich. Die künftige CO₂-Preisentwicklung ist unsicher, daher werden die möglichen CO₂-Kosten anhand von drei angenommenen CO₂-Preisen für den Zeitraum 2025 bis 2034 berechnet. Die tatsächlichen CO₂-Preise können sowohl höher als auch niedriger als in den hier zugrundeliegenden Modellrechnungen ausfallen. Die CO₂- Kosten sind beim Tanken mit den Kraftstoffkosten zu bezahlen. Weitere Informationen unter www.alternativ-mobil.info',
	'ngc.technicalData.envkv.co2Tax': 'Kraftfahrzeugsteuer:',
	'ngc.technicalData.envkv.co2Tax.remark':
		'Die Steuerbefreiung wird bei erstmaliger Zulassung des Elektrofahrzeugs in der Zeit vom 18.05.2011 bis 31.12.2025 für zehn Jahre ab dem Tag der erstmaligen Zulassung gewährt, längstens jedoch bis zum 31.12.2030.',
	'ngc.technicalData.envkv.remark1':
		'Die Informationen erfolgen gemäß der PKW-Energieverbrauchskennzeichnungsverordnung. Die angegebenen Werte wurden nach dem vorgeschriebenen Messverfahren WLTP (Worldwide harmonised Light-duty Test Procedures) ermittelt. Der Kraftstoffverbrauch und der CO₂-Ausstoß eines Pkw sind nicht nur von den effizienten Ausnutzung des Kraftstoffs durch den Pkw, sondern auch vom Fahrstil und anderen nichttechnischen Faktoren abhänging. CO₂ ist das für die Erderwärmung hauptsächlich verantwortliche Treibhausgas. Ein Leitfaden über den Kraftstoffverbrauch und die CO₂- Emissionen aller in Deutschland angebotenen neuen Pkw-Modelle ist unentgeltlich einsehbar an jedem Verkaufsort in Deutschland, an dem neue Pkw ausgestellt oder angeboten werden. Der Leitfaden ist auch hier aufrufbar: http://www.dat.de/co2/.',
	'ngc.technicalData.envkv.pdf.label':
		'Informationen über den Energieverbrauch und die CO₂-Emissonen des neuen PKW herunterladen',
	'ngc.technicalData.envkv.fin': 'Fahrzeug-Identifikationsnummer (FIN):',
	'ngc.technicalData.envkv.date': 'erstellt am:',
	'ngc.technicalData.fuelType.petrol': 'Petrol',
	'ngc.technicalData.fuelType.diesel': 'Diesel',
	'ngc.technicalData.fuelType.power': 'Power',
	'ngc.types.ConfiguredCarFeature.ACCESSORY': 'Accessory',
	'ngc.types.ConfiguredCarFeature.BODY_COLOR': 'Body Color',
	'ngc.types.ConfiguredCarFeature.EQUIPMENT_CONTENT': 'Equipment Content',
	'ngc.types.ConfiguredCarFeature.EQUIPMENT': 'Equipment',
	'ngc.types.ConfiguredCarFeature.EXCLUSIVE_EXTERIOR_COLOR': 'Exclusive Exterior Color',
	'ngc.types.ConfiguredCarFeature.EXTERIOR_COLOR': 'Exterior Color',
	'ngc.types.ConfiguredCarFeature.INTERIOR_TILE': 'Interior Tile',
	'ngc.types.ConfiguredCarFeature.MODEL': 'Model',
	'ngc.types.ConfiguredCarFeature.RAW_INTERIOR_COLOR': 'Interior Color',
	'ngc.types.ConfiguredCarFeature.ROOF_COLOR': 'Roof Color',
	'ngc.types.ConfiguredCarFeature.STEALTH': 'Stealth',
	'ngc.types.ConfiguredCarFeature.TRIMLINE': 'Trimline',
	'ngc.stockcar.trigger': 'Find your match',
	'ngc.stockcar.location.search': 'Search for your location',
	'ngc.stockcar.location.automatic': 'Use your location',
	'ngc.stockcar.location.radius': 'Set your radius',
	'ngc.stockcar.matches.open': 'View your matches',
	'ngc.stockcar.location.notfound': 'No location found.',
	'ngc.stockcar.location.automatic.denied': 'Access to your current location was denied by the browser',
	'ngc.stockcar.location.automatic.unsupported': 'Your browser does not support auto location',
	'ngc.stockcar.matches.title': 'Top matches ready for you',
	'ngc.stockcar.matches.subheader': 'Similar vehicles based on your current configuration.',
	'ngc.stockcar.matches.disclaimer':
		'An approximate percentage value is given as an indication of the similarities between your configuration and the vehicles shown here.',
	'ngc.stockcar.matches.filter.price.trigger': 'Filter by price',
	'ngc.stockcar.matches.filter.price.title': 'Price',
	'ngc.stockcar.matches.filter.price.rangeSeparator': 'to',
	'ngc.stockcar.matches.differing': 'Differing features',
	'ngc.stockcar.matches.match': 'Match',
	'ngc.stockcar.matches.more': 'Show {{results}} More Results',
	'ngc.stockcar.matches.details': 'More details',
	'ngc.stockcar.matches.notfound.title': 'Sorry! No matches found.',
	'ngc.stockcar.matches.notfound.description':
		'You can always try to Expand the radius or change the address, city or zip code to improve your results.',
	'ngc.stockcar.matches.price.legalICE': 'Stock-Car ICE price legal disclaimer text.',
	'ngc.stockcar.matches.price.legalBEV': 'Stock-Car BEV price legal disclaimer text.',
	'ngc.remarks.price.legalBEV': 'Price disclaimer Text for BEV vehicles - or default disclaimer.',
	'ngc.remarks.price.legalICE': 'Price disclaimer for combustion engine models.',
	'ngc.incentives.sectionTitle': 'Available discounts',
	'ngc.incentives.sectionTitle.tooltip':
		'Discounts may apply depending on current campaigns or certain purchase conditions.',
	'ngc.incentives.lowestPrice': 'Lowest price in the last 30 days',
	'ngc.incentives.termsAndConditions': 'Terms & Conditions',
	'ngc.incentives.validUntil': 'Gültig bis {{date}}.',
	'ngc.incentives.description': 'Description',
	'ngc.incentives.promotion': 'Promotion',
	'ngc.incentives.promotionPeriod': 'Promotion period',
	'ngc.incentives.eligibility': 'Eligibility',
	'ngc.incentives.proof': 'Proof',
	'ngc.incentives.eligibilityVehicle': 'Eligibility vehicle',
	'ngc.incentives.legalLimitation': 'Legal limitation',
	'ngc.incentives.popover.trigger': 'Deal available',
	'ngc.engineFilter.title': 'Filter by category',
	'ngc.engineFilter.noResults': 'Sorry, there are no engines matching your criteria',
	'ngc.engineFilter.category.gearType': 'Gear type',
	'ngc.engineFilter.category.engineTechnology': 'Fuel',
	'ngc.engineFilter.category.drive': 'Drive type',
	'ngc.engineFilter.gearType.automatic': 'Automatic',
	'ngc.engineFilter.gearType.manual': 'Manual',
	'ngc.engineFilter.engineTechnology.petrol': 'Petrol',
	'ngc.engineFilter.engineTechnology.diesel': 'Diesel',
	'ngc.engineFilter.engineTechnology.hybrid': 'Hybrid',
	'ngc.engineFilter.engineTechnology.electro': 'Electro',
	'ngc.engineFilter.drive.quattro': 'Quattro',
	'ngc.engineFilter.drive.front_wheel_drive': 'Front wheel drive',
	'ngc.engineFilter.drive.rear_wheel_drive': 'Rear wheel drive',
	'ngc.filter.by': 'Filter by',
	'ngc.filter.exclusiveColors': 'Exclusive colors',
	'ngc.filter.colors': 'Colors',
	'ngc.filter.notFound': 'Sorry, there are no items matching your filter criteria.',
	'ngc.disclaimer.category.info': 'Important information',
	'ngc.disclaimer.exclusiveColor.headline': '',
	'ngc.disclaimer.exclusiveColor.content': '',
	'ngc.actions.showLess': 'Show less',
	'ngc.actions.showMore': 'Show more',
	'ngc.gpsr.headline': 'Information about General Product Safety Regulation (GPSR)',
	'ngc.gpsr.buttonLabel': 'Access Product Safety Information',
	'ngc.gpsr.url': '',
	'ngc.rescueInfo.headline': 'Your Audi Code {{code}}',
	'ngc.rescueInfo.audiCodeNotAvailable':
		'The Audi code is no longer current and the configuration could not be loaded.',
	'ngc.rescueInfo.alternativeConfiguration': 'We have an alternative configuration with the following adjustments:',
	'ngc.rescueInfo.loadUpdatedConfiguration': 'Load updated configuration',
	'ngc.rescueInfo.startWithBaseConfiguration': 'Start with base configuration',
	'ngc.rescueInfo.baseModelChange': 'Model',
	'ngc.rescueInfo.extColorChanged': 'Exterior Color',
	'ngc.rescueInfo.equipmentChange': 'Equipment',
	'ngc.rescueInfo.priceChange': 'Price',
	'ngc.rescueInfo.financingConditionsChanged': 'Financial conditions',
	'ngc.rescueInfo.audiOriginalAccessories': 'Audi Genuine Accessory',
	'ngc.rescueInfo.engineChange': 'Engine',
	'ngc.actions.saveConfiguration': 'Save configuration',
	'ngc.audiCode.copy': 'Copy',
	'ngc.saveConfiguration.audicode.subheader':
		'With your Audi code, you can easily retrieve your personalized configuration:',
	'ngc.saveConfiguration.disclaimer.title': 'Loading your configuration from an Audi code',
	'ngc.saveConfiguration.disclaimer.message':
		'To access your saved configuration, copy your 8-digit Audi code and paste it into the search field, or click the link below:',
	'ngc.saveConfiguration.myAudi.wishlist.url': '',
	'ngc.saveConfiguration.myAudi.save': 'Save configuration',
	'ngc.saveConfiguration.myAudi.login': 'Login myAudi',
	'ngc.saveConfiguration.myAudi.wishlist': 'Open My Wishlist',
	'ngc.saveConfiguration.myAudi.headline': 'Save Configuration on myAudi',
	'ngc.saveConfiguration.myAudi.subheadline.logout':
		'To save your current configuration to your myAudi account, please log in or sign up on myAudi.',
	'ngc.saveConfiguration.myAudi.subheadline.login': 'Store your configuration for seamless access across devices.',
	'ngc.saveConfiguration.myAudi.benefits.headline': 'Advantages of myAudi',
	'ngc.saveConfiguration.myAudi.benefits.content':
		'<ul><li>Review your saved configurations</li><li>Access and edit them at any time</li><li>Receive personal offers from your Audi partner</li></ul>',
	'ngc.saveConfiguration.success.title': 'Your configuration was saved successfully!',
	'ngc.saveConfiguration.error.title': 'Your configuration could not be saved!',
	'ngc.saveConfiguration.success.message': 'View your car in the ‘My wishlist’ section of your myAudi account.',
	'ngc.saveConfiguration.generalError.message':
		'An error occurred while saving configuration, copy your Audicode to save your configuration manually',
	'ngc.saveConfiguration.noSpaceError.message':
		'Maximum number of configurations reached. Consider removing configurations that you no longer need.',
};
